import React from 'react';

import { A11yWrapper } from 'components/a11y-wrapper';
import Currency from 'components/currency';
import { CurrencyLineSkeleton } from 'pages/cart/currency-line-skeleton';
import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants/primitives';

import { Total, TotalLabel, TotalsRow } from './styled';
import { RewardRow } from './subtotal.styled';
import { IRenderTotalsProps } from './types';
import { getFeesByGroup, getStandardizedName } from './utils';

export const RenderTotals: React.FC<React.PropsWithChildren<IRenderTotalsProps>> = ({
  cart = {},
  otherDiscountAmount,
  rewardDiscount,
  isLoading,
}) => {
  const { subTotalCents = 0, fees = [] } = cart;

  const itemFees = getFeesByGroup(fees || []);

  return (
    <>
      {!!rewardDiscount &&
        (isLoading ? (
          <CurrencyLineSkeleton />
        ) : (
          <RewardRow>
            <A11yWrapper>
              <TotalLabel color={primitive.bk.$crunchyGreen}>{t('rewardSavings')}</TotalLabel>
            </A11yWrapper>
            <Total testID="reward-savings">
              <Currency
                prefix="- "
                amount={rewardDiscount}
                textProps={{ color: primitive.bk.$crunchyGreen, fontSize: 'md' }}
              />
            </Total>
          </RewardRow>
        ))}
      {!!otherDiscountAmount &&
        (isLoading ? (
          <CurrencyLineSkeleton />
        ) : (
          <RewardRow>
            <A11yWrapper>
              <TotalLabel>{t('comboOfferSavings')}</TotalLabel>
            </A11yWrapper>
            <Total testID="discount-savings">
              <Currency prefix="- " amount={otherDiscountAmount} textProps={{ fontSize: 'md' }} />
            </Total>
          </RewardRow>
        ))}

      {isLoading ? (
        <CurrencyLineSkeleton />
      ) : (
        <TotalsRow>
          <A11yWrapper>
            <TotalLabel>{t('subtotal')}</TotalLabel>
          </A11yWrapper>
          <Total testID="subtotal">
            <Currency amount={Math.max(subTotalCents, 0)} textProps={{ fontSize: 'md' }} />
          </Total>
        </TotalsRow>
      )}
      {!!itemFees &&
        Object.entries(itemFees).map(([name, entryCents]: [string, number], index) =>
          isLoading ? (
            <CurrencyLineSkeleton />
          ) : (
            <TotalsRow key={index}>
              <A11yWrapper>
                <TotalLabel testID={`fee-name-${name}`}>
                  {t(`${getStandardizedName({ name })}Fee`, `${name} Fee`)}
                </TotalLabel>
              </A11yWrapper>
              <Total testID={`fee-amount-${name}`}>
                <Currency amount={entryCents} textProps={{ fontSize: 'md' }} />
              </Total>
            </TotalsRow>
          )
        )}
    </>
  );
};

export default RenderTotals;
